<template>
    <div v-if="editedItem">
        <div class="installment_product_wrapper">
            <div class="page page2">
                <table class="leftBox">
                    <tr>
                        <td width="102px">{{editedItem.header.caseType}}</td>
                        <td v-if="editedItem.vendor.productId !== '2'"><span style="font-size: 20px;">{{editedItem.header.caseType4}}</span></td>
                        <td v-if="editedItem.vendor.productId === '2'" width="56px"><input type="checkbox" disabled="" checked id="checkbox-1">
                          <label v-if="editedItem.header.type[0].value" for="checkbox-1">
                          <img :src="checkedImage"></label></td>
                        <td><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.header.type[1].value" for="checkbox-1"><img :src="checkedImage"></label></td>
                    </tr>
                </table>
                <span style="margin-top: 1px; float: right; font-size: 12px;">{{getCaseProduct(editedItem.vendor)}}({{getCaseVersion(editedItem)}})</span>
                <div class="blueBox blueBox1">
                    <div class="date">
                        申請日期：<span class="y">{{editedItem.applyDate.year}}</span>年<span class="m">{{editedItem.applyDate.month}}</span>月<span class="d">{{editedItem.applyDate.day}}</span>日
                    </div>
                    <table class="blueTable blueTable1">
                        <tr>
                            <th width="47px">中&nbsp;文<br/>姓&nbsp;名</th>
                            <td width="115px" class="signImg"></td>
                            <th width="48px">身分證<br/>字&nbsp;&nbsp;&nbsp;&nbsp;號</th>
                            <td>{{editedItem.customer.memberId}}</td>
                        </tr>
                        <tr>
                            <th>出&nbsp;生<br/>日&nbsp;期</th>
                            <td class="hidden1">
                                <span class="y">{{editedItem.customer.birthdayInfo ? convertYear(editedItem.customer.birthdayInfo.year) : ''}}</span>年
                                <span class="m">{{editedItem.customer.birthdayInfo ? editedItem.customer.birthdayInfo.month :''}}</span>月
                                <span class="d">{{editedItem.customer.birthdayInfo ? editedItem.customer.birthdayInfo.day: ''}}</span>日
                            </td>
                            <th>婚&nbsp;姻<br/>狀&nbsp;況</th>
                            <td>
                                <div class="checkDiv"><span class="checkbox checkbox1"><input type="checkbox" disabled checked  id="checkbox-1"><label v-if="editedItem.customer.married[0].value === true" for="checkbox-1"><img :src="checkedImage"></label></span>已婚</div>
                                <div class="checkDiv"><span class="checkbox checkbox2"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.married[1].value === true" for="checkbox-1"><img :src="checkedImage"></label></span>未婚</div><br/>
                                <div class="checkDiv"><span class="checkbox checkbox3"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.hasChild" for="checkbox-1"><img :src="checkedImage"></label></span>子女<span class="nb">{{editedItem.customer.childCount}}</span>人</div>
                            </td>
                        </tr>
                    </table><!--blueTable1-->
                    <table class="blueTable blueTable2">
                        <tr>
                            <th width="47px">身分證<br/>初補換</th>
                            <td width="163px">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox4"><input type="checkbox" disabled checked id="checkbox-1">
                                        <label v-if="editedItem.customer.memberIdType[0].value === true" for="checkbox-1"><img :src="checkedImage"></label></span>初發<br/>
                                    <span class="checkbox checkbox5"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.memberIdType[1].value === true" for="checkbox-1"><img :src="checkedImage"></label></span>補發<br/><span class="checkbox checkbox6"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.memberIdType[2].value === true" for="checkbox-1"><img :src="checkedImage"></label></span>換發
                                </div>
                                <div class="date2">
                                    <span class="y">{{editedItem.customer.memberIdDateInfo ? editedItem.customer.memberIdDateInfo.year : ''}}</span>年
                                    <span class="m">{{editedItem.customer.memberIdDateInfo ? editedItem.customer.memberIdDateInfo.month : ''}}</span>月
                                    <span class="d">{{editedItem.customer.memberIdDateInfo ? editedItem.customer.memberIdDateInfo.day : ''}}</span>日
                                </div>
                            </td>
                            <th width="50px">發&nbsp;證<br/>地&nbsp;點</th>
                            <td v-if="checkMemberIdCityNumberType">{{getMemberIdCity(editedItem.customer.memberIdCity)}}</td>
                            <td v-else>{{editedItem.customer.memberIdCity}}</td>
                        </tr>
                    </table><!--blueTable2-->
                    <table class="blueTable blueTable3">
                        <tr>
                            <th width="47px">戶&nbsp;籍<br/>電&nbsp;話</th>
                            <td width="115px" class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox7"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.hasPhone" for="checkbox-1"><img :src="checkedImage"></label></span>無
                                </div>
                                {{editedItem.customer.phone}}
                            </td>
                            <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox8"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.hasHomePhone" for="checkbox-1"><img :src="checkedImage"></label></span>無
                                </div>
                                {{editedItem.customer.homePhone}}
                            </td>
                        </tr>
                        <tr>
                            <th>行&nbsp;動<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox9"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.hasCellphone" for="checkbox-1"><img :src="checkedImage"></label></span>無
                                </div>
                                {{editedItem.customer.cellphone}}
                            </td>
                            <th>教&nbsp;育<br/>程&nbsp;度</th>
                            <td>
                                <div class="checkDiv checkDiv3">
                                    <span class="checkbox checkbox10"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.educationLevel[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>博士
                                    <span class="checkbox checkbox11"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.educationLevel[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>碩士
                                    <span class="checkbox checkbox12"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.educationLevel[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>大學
                                    <span class="checkbox checkbox13"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.educationLevel[3].value" for="checkbox-1"><img :src="checkedImage"></label></span>專科
                                    <span class="checkbox checkbox14"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.educationLevel[4].value" for="checkbox-1"><img :src="checkedImage"></label></span>高中職
                                    <span class="checkbox checkbox15"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.customer.educationLevel[5].value" for="checkbox-1"><img :src="checkedImage"></label></span>其他
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>戶&nbsp;籍<br/>地&nbsp;址</th>
                            <td colspan="3">{{editedItem.customer.home.residenceAddress}}</td>
                        </tr>
                        <tr>
                            <th>住&nbsp;宅<br/>地&nbsp;址</th>
                            <td colspan="3" class="td-address4">
                                <div class="checkDiv checkDiv4">
                                    <span class="checkbox checkbox16"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.homeType1[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>同戶籍
                                    <span class="checkbox checkbox17"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.homeType1[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>另列如下
                                </div>
                                {{editedItem.customer.home.homeAddress1}}
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>
                                <div class="date3">
                                    <span class="y">{{editedItem.customer.home.liveYear}}</span>年
                                    <span class="m">{{editedItem.customer.home.liveMonth}}</span>月
                                </div>
                            </td>
                            <th></th>
                            <td>
                                <div class="checkDiv checkDiv5">
                                    <span class="checkbox checkbox18"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.liveLevel[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>本人名下
                                    <span class="checkbox checkbox19"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.liveLevel[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>配偶名下<br/>
                                    <span class="checkbox checkbox20"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.liveLevel[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>親友
                                    <span class="checkbox checkbox21"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.liveLevel[3].value" for="checkbox-1"><img :src="checkedImage"></label></span>租賃
                                    <span class="checkbox checkbox22"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.liveLevel[4].value" for="checkbox-1"><img :src="checkedImage"></label></span>宿舍
                                    <span class="checkbox checkbox23"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.home.liveLevel[5].value" for="checkbox-1"><img :src="checkedImage"></label></span>其他
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>繳&nbsp;款<br/>方&nbsp;式</th>
                            <td colspan="3" class="td-address6">
                                <div class="checkDiv checkDiv24"><span class="checkbox checkbox24"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.usePhonePayment" for="checkbox-1"></label></span>簡訊條碼繳款</div>
                                <div class="checkDiv checkDiv25"><span class="checkbox checkbox25"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.useElectronicBill" for="checkbox-1"></label></span>電子帳單(請填E-mail)</div><br/>
                                {{editedItem.customer.paymentEmail}}
                            </td>
                        </tr>
                        <tr>
                            <th>E-mail</th>
                            <td colspan="3" class="td-email">
                                <div class="checkDiv"><span class="checkbox checkbox26"><input type="checkbox" checked disabled id="checkbox-1"><label v-if="editedItem.customer.hasMail" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                {{editedItem.customer.email}}
                            </td>
                        </tr>
                    </table><!--blueTable3-->
                </div><!--blueBox1-->
                <div class="blueBox blueBox2">
                    <table class="blueTable blueTable4">
                        <tr>
                            <th width="47px">公&nbsp;司<br/>名&nbsp;稱</th>
                            <td width="137px" class="td-com">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox27"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.company.type[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>無
                                    <span class="checkbox checkbox28"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.company.type[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>家管
                                    <span class="checkbox checkbox29"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.company.type[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>另列如下
                                </div>
                                {{editedItem.company.name}}
                            </td>
                            <th width="47px">公&nbsp;司<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox30"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.company.hasPhone" for="checkbox-1"><img :src="checkedImage"></label></span>無
                                </div>
                                {{editedItem.company.phone}}
                            </td>
                        </tr>
                        <tr>
                            <th>公&nbsp;司<br/>地&nbsp;址</th>
                            <td class="td-address" colspan="3">
                                <div class="checkDiv">
                                    <span class="checkbox checkbox31"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.company.hasAddress" for="checkbox-1"><img :src="checkedImage"></label></span>無
                                </div>
                                {{editedItem.company.address}}
                            </td>
                        </tr>
                    </table><!--blueTable4-->
                    <table class="blueTable blueTable5">
                        <tr>
                            <th width="47px">職稱</th>
                            <td width="93px">{{editedItem.company.title}}</td>
                            <th width="32px">年資</th>
                            <td width="74px">
                                <div class="date4">
                                    <span class="y">{{editedItem.company.workYear}}</span>年
                                    <span class="m">{{editedItem.company.workMonth}}</span>月
                                </div>
                            </td>
                            <th width="33px">月薪</th>
                            <td class="hidden2"><span class="salary">{{editedItem.company.salary}}</span>元</td>
                        </tr>
                    </table><!--blueTable5-->
                    <div class="blueBox blueBox3">
                        <div class="checkDiv"><span class="checkbox checkbox32"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.bank.type[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>沒辦過卡</div>
                        <div class="checkDiv"><span class="checkbox checkbox33"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.bank.type[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>無卡自停</div>
                        <div class="checkDiv"><span class="checkbox checkbox34"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.bank.type[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>協商繳款中</div>
                        <div class="checkDiv"><span class="checkbox checkbox35"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.bank.type[3].value" for="checkbox-1"><img :src="checkedImage"></label></span><div class="others">{{editedItem.bank.otherType}}</div></div>
                        <table class="blueTable blueTable6">
                            <tr>
                                <th width="47px">發&nbsp;卡<br/>銀&nbsp;行</th>
                                <td width="127px">{{editedItem.bank.name}}</td>
                                <th width="49px">有&nbsp;效<br/>日&nbsp;期</th>
                                <td>
                                    <div class="date5">
                                        <span class="m">{{editedItem.bank.effectiveMonth}}</span>月
                                        <span class="y">{{editedItem.bank.effectiveYear}}</span>年
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>卡號</th>
                                <td colspan="3" class="cardNb">{{editedItem.bank.creditCard}}<span class="ps">(請填寫本人正卡資料)</span></td>
                            </tr>
                        </table><!--blueTable6-->
                    </div><!--blueBox3-->
                    <div class="blueBox blueBox4">
                        <table class="blueTable blueTable7">
                            <tr>
                                <th width="47px">中&nbsp;文<br/>姓&nbsp;名</th>
                                <td width="111px">{{editedItem.firstContact.name}}</td>
                                <th width="27px">關係</th>
                                <td width="38px" class="text_c">{{editedItem.firstContact.type}}</td>
                                <th width="46px">行&nbsp;動<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    <div class="checkDiv"><span class="checkbox checkbox36"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.firstContact.hasCellphone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                    {{editedItem.firstContact.cellphone}}
                                </td>
                            </tr>
                        </table><!--blueTable7-->
                        <table class="blueTable blueTable8">
                            <tr>
                                <th width="47px">住&nbsp;宅<br/>電&nbsp;話</th>
                                <td width="138px" class="td-phone">
                                    <div class="checkDiv"><span class="checkbox checkbox37"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.firstContact.hasHomePhone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                    {{editedItem.firstContact.homePhone}}
                                </td>
                                <th width="38px">公&nbsp;司<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    <div class="checkDiv"><span class="checkbox checkbox38"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.firstContact.hasCompanyPhone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                    {{editedItem.firstContact.companyPhone}}
                                </td>
                            </tr>
                        </table><!--blueTable8-->
                        <table class="blueTable blueTable9">
                            <tr>
                                <th width="47px">中&nbsp;文<br/>姓&nbsp;名</th>
                                <td width="111px">{{editedItem.secondContact.name}}</td>
                                <th width="27px">關係</th>
                                <td width="38px" class="text_c">{{editedItem.secondContact.type}}</td>
                                <th width="46px">行&nbsp;動<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    <div class="checkDiv"><span class="checkbox checkbox39"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.secondContact.hasCellphone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                    {{editedItem.secondContact.cellphone}}
                                </td>
                            </tr>
                        </table><!--blueTable9-->
                        <table class="blueTable blueTable10">
                            <tr>
                                <th width="47px">住&nbsp;宅<br/>電&nbsp;話</th>
                                <td width="138px" class="td-phone">
                                    <div class="checkDiv"><span class="checkbox checkbox40"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.secondContact.hasHomePhone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                    {{editedItem.secondContact.homePhone}}
                                </td>
                                <th width="38px">公&nbsp;司<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    {{editedItem.secondContact.companyPhone}}
                                </td>
                            </tr>
                        </table><!--blueTable10-->
                    </div><!--blueBox4-->
                </div><!--blueBox2-->
                <div class="redBox">
                    <div class="ps">
                        <div class="checkDiv"><span class="checkbox checkbox41"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.hasJointGuarantor[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>連帶保證人(需附保證人身分證正反面影本及簽名)</div>
                        <div class="checkDiv"><span class="checkbox checkbox42"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.hasJointGuarantor[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>配偶資料僅供參考</div>
                        <div class="checkDiv"><span class="checkbox checkbox43"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.hasJointGuarantor[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>法定代理人(須於法代欄位簽名)</div>
                        <div class="checkDiv"><span class="checkbox checkbox44"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.hasJointGuarantor[3].value" for="checkbox-1"><img :src="checkedImage"></label></span>商品實際使用人</div>
                    </div>
                    <table class="redTable">
                        <tr>
                            <th width="47px">姓&nbsp;名</th>
                            <td width="158px">{{editedItem.jointGuarantor.name}}</td>
                            <th width="57px">關&nbsp;係</th>
                            <td width="82px">{{editedItem.jointGuarantor.type}}</td>
                            <th width="47px">身分證<br/>字&nbsp;&nbsp;號</th>
                            <td width="153px">{{editedItem.jointGuarantor.memberId}}</td>
                            <th width="47px">出&nbsp;生<br/>日&nbsp;期</th>
                            <td>
                                <div class="date6">
                                    <span class="y">{{editedItem.jointGuarantor.birthdayInfo ? convertYear(editedItem.jointGuarantor.birthdayInfo.year) : ''}}</span>年
                                    <span class="m">{{editedItem.jointGuarantor.birthdayInfo ? editedItem.jointGuarantor.birthdayInfo.month : ''}}</span>月
                                    <span class="d">{{editedItem.jointGuarantor.birthdayInfo ? editedItem.jointGuarantor.birthdayInfo.day : ''}}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>身分證<br/>初補換</th>
                            <td>
                                <div class="checkDiv">
                                    <span class="checkbox checkbox45"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.memberIdType[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>初發<br/>
                                    <span class="checkbox checkbox46"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.memberIdType[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>補發<br/>
                                    <span class="checkbox checkbox47"><input type="checkbox" disabled checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.memberIdType[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>換發
                                </div>
                                <div class="date7">
                                    <span class="y">{{editedItem.jointGuarantor.memberIdDateInfo ? editedItem.jointGuarantor.memberIdDateInfo.year :''}}</span>年
                                    <span class="m">{{editedItem.jointGuarantor.memberIdDateInfo ? editedItem.jointGuarantor.memberIdDateInfo.month :''}}</span>月
                                    <span class="d">{{editedItem.jointGuarantor.memberIdDateInfo ? editedItem.jointGuarantor.memberIdDateInfo.day :''}}</span>日
                                </div>
                            </td>
                            <th>發&nbsp;證<br/>地&nbsp;點</th>
                            <td>{{editedItem.jointGuarantor.memberIdCity}}</td>
                            <th>住&nbsp;家<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox48"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.hasHomePhone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                {{editedItem.jointGuarantor.homePhone}}
                            </td>
                            <th>行&nbsp;動<br/>電&nbsp;話</th>
                            <td  class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox49"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.hasCellphone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                {{editedItem.jointGuarantor.cellphone}}
                            </td>
                        </tr>
                        <tr>
                            <th>公&nbsp;司<br/>名&nbsp;稱</th>
                            <td colspan="3">{{editedItem.jointGuarantor.companyName}}</td>
                            <th>職&nbsp;稱</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox50"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.hasTitle" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                {{editedItem.jointGuarantor.title}}
                            </td>
                            <th>公&nbsp;司<br/>電&nbsp;話</th>
                            <td  class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox51"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.jointGuarantor.hasCompanyPhone" for="checkbox-1"><img :src="checkedImage"></label></span>無</div>
                                {{editedItem.jointGuarantor.companyPhone}}
                                <span class="ext">分機<span>{{editedItem.jointGuarantor.companySubPhone}}</span></span>
                            </td>
                        </tr>
                    </table><!--redTable-->
                </div><!--redBox-->
                <div class="yBox">
                    <div class="ps">
                        <div class="checkDiv"><span class="checkbox checkbox52"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.type[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>新件</div>
                        <div class="checkDiv"><span class="checkbox checkbox53"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.type[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>補保人</div>
                        <div class="checkDiv"><span class="checkbox checkbox54"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.type[2].value" for="checkbox-1"><img :src="checkedImage"></label></span>補資料</div>
                        <div class="checkDiv"><span class="checkbox checkbox55"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.interestRate[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>零利率</div>
                        <div class="checkDiv"><span class="checkbox checkbox56"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.interestRate[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>低利率</div>
                        <div class="checkDiv"><span class="checkbox checkbox57"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.category[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>ㄧ般件</div>
                        <div class="checkDiv"><span class="checkbox checkbox58"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.caseInfo.category[1].value" for="checkbox-1"><img :src="checkedImage"></label></span>保密件</div>
                    </div>

                    <table class="yTable1">
                        <tr>
<!--                          {{getCaseProduct(editedItem.vendor)}}-->
                            <td width="112px">機車</td>
                            <td width="71px">{{editedItem.vendor.deposit === 0 ? '' : editedItem.vendor.deposit}}</td>
                            <td width="65px">{{editedItem.vendor.totalPrice === 0 ? '' : editedItem.vendor.totalPrice}}</td>
                            <td width="157px">{{editedItem.vendor.creditPrice === 0 ? '' : editedItem.vendor.creditPrice}}</td>
                            <td width="43px">{{editedItem.vendor.installmentsNumber}}</td>
                            <td width="129px">{{editedItem.vendor.creditPriceMonth === 0 ? '' : editedItem.vendor.creditPriceMonth}}</td>
                            <td>{{editedItem.vendor.totalCreditPrice === 0 ? '' : editedItem.vendor.totalCreditPrice}}</td>
                        </tr>
                    </table><!--yTable1-->
                    <table class="yTable2">
                        <tr>
                            <th width="70px">
                                <span class="th1">經銷商或<br/>債權讓與人名稱<br/>(約定受款方)</span></th>
                            <td width="131px">{{editedItem.vendor.vendorName}}</td>
                            <th width="65px">
                                <span class="th2">經銷商或<br/>債權讓與人<br/>電話</span>
                            </th>
                            <td width="105px" class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox59"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.hasCellphone" for="checkbox-1"><img :src="checkedImage"></label></span>無電話請打手機聯絡</div>
                                {{editedItem.vendor.cellphone}}
                            </td>
                            <th width="52px">
                                <span class="th3">經銷商或<br/>債權讓與人<br/>傳真</span>
                            </th>
                            <td width="110px" class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox60"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.hasFax" for="checkbox-1"><img :src="checkedImage"></label></span>無傳真請電話通知</div>
                                {{editedItem.vendor.fax}}
                            </td>
                            <th rowspan="3" class="sign1">
                                <span class="bg"></span>
                                <span class="txt">(請蓋公司大小章或發票章)</span>

                            </th>
                        </tr>
                        <tr>
                            <th>經辦店名稱</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox61"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.sameVendor" for="checkbox-1"><img :src="checkedImage"></label></span>同經銷商或債權讓與人</div>
                                {{editedItem.vendor.salesName}}
                            </td>
                            <th>經辦店<br/>電&nbsp;&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox checkbox62"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.hasSalesPhone" for="checkbox-1"><img :src="checkedImage"></label></span>無電話請打手機聯絡</div>
                                {{editedItem.vendor.salesPhone}}
                            </td>
                            <th>經辦人<br/>手&nbsp;&nbsp;機</th>
                            <td>{{editedItem.vendor.salesCellphone}}</td>
                        </tr>
                        <tr>
                            <td colspan="6" class="td-phone td-phone2">

                                <div class="checkDiv checkDiv2">
                                    經銷商備註欄：<br/>
                                    <span class="checkbox checkbox63"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.type[0].value" for="checkbox-1"><img :src="checkedImage"></label></span>熟客&nbsp;
                                    <span class="checkbox checkbox64"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.type[1].value"  for="checkbox-1"><img :src="checkedImage"></label></span>過路客&nbsp;
                                    <span class="checkbox checkbox65"><input type="checkbox" disabled="" checked id="checkbox-1"><label v-if="editedItem.vendor.type[2].value"  for="checkbox-1"><img :src="checkedImage"></label></span>
                                    指定照會時間：<span class="m">{{editedItem.vendor.checkTime.month}}</span>月<span class="d">{{editedItem.vendor.checkTime.day}}</span>日<span class="t"></span>午<span class="h">{{editedItem.vendor.checkTime.hour}}</span>點<span class="min">{{editedItem.vendor.checkTime.minute}}</span>分
                                </div>
                                <span class="ps2">{{editedItem.vendor.comment}}</span>
                                <div class="sign2">
                                    經辦人簽名
                                    <span class="bg">{{editedItem.vendor.signature}}</span>
                                    <span class="txt">本人證實申請人及連帶保證人身分正確並親自簽章無誤</span>
                                </div>
                            </td>
                        </tr>
                    </table><!--yTable2-->
                </div><!--yBox-->

            </div><!--page2-->

        </div><!--wrapper-->

        <v-app v-if="editedItem.imageList && editedItem.imageList.length">
            <div class="photo_page_wrapper" v-if="editedItem.imageList && editedItem.imageList.length > 6 && editedItem.imageList.length <= 12">
                <div class="page">
                    <v-layout md12 row wrap>
                        <v-flex md6 mt-2  v-for="(image, i) in editedItem.imageList"
                                :key="i" v-if="i > 6 && i <= 12"><div class="box" ><img  :src="image.data"></div></v-flex>
                    </v-layout>
                    <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
                </div><!--page-->
            </div><!--wrapper-->

            <div class="photo_page_wrapper" v-if="editedItem.imageList && editedItem.imageList.length > 12">
                <div class="page">
                    <v-layout md12 row wrap>
                        <v-flex md6 mt-2  v-for="(image, i) in editedItem.imageList"
                                :key="i" v-if="i > 12 && i <= 18"><div class="box" ><img  :src="image.data"></div></v-flex>
                    </v-layout>
                    <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
                </div><!--page-->
            </div><!--wrapper-->
        </v-app>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {yearPadLeft } from '@/pages/utils/tool';
    import common from '../../mixins/common';

    export default {
        name: "InstallmentProductPrint",
        props: {
            item: Object,
        },
        mixins:[common],
        data() {
            return {
                checkedImage: require('../../assets/images/checked.png'),
                createDate: '',
            }
        },
        created() {
            // const caseId = this.$route.query.caseId;
            // if (caseId){
            //     this.fetchFinanceCreditInfo({caseId: caseId}).then(results=>{
            //         if (results.length){
            //             this.item = results[0];
            //             console.log(`fetchFinanceCreditInfo ${JSON.stringify(this.item)}`);
            //         }
            //     });
            // }
        },        
        computed: {
            ...mapGetters(['getUserInfo']),
            editedItem() {
                console.log(`item ===  ${JSON.stringify(this.item)}`);
                return this.item;
            },
            checkMemberIdCityNumberType() {
                if(this.item) {
                    const parsed = parseInt(this.item.customer.memberIdCity, 10);
                    return isNaN(parsed)
                } else {
                    return false;
                }
            }
        },
        methods: {
            ...mapActions(['fetchFinanceCreditInfo',]),
          getCaseProduct(item) {
            if (item.productId === '0') {
              return '原車';
            }
            if (item.productId === '1') {
              return '借新';
            }
            if (item.productId === '2') {
              return '他行';
            }
            return '原車';
          },
          getMemberIdCity(value) {
            value =  value.replace(/ /g,'')
            if(!value) {
                return ""
            }
            console.log(`getMemberIdCity ${value}`)
            const memberIdCitylist = this.getMemberIdCityList.filter(m=>m.key === value);
            if (memberIdCitylist.length > 0 ) {
                return memberIdCitylist[0].value;
            }
            return value
          },
          getCaseVersion(item) {
            if(item.tab === '1') {
                return '新';
            }
            if(item.tab === '2') {
                return '舊';
            }
            return '舊';
          },
          convertYear(val){
            return yearPadLeft(val);
          }
        }
    }
</script>

<style scoped src="../../assets/css/installment_product_print.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/InstallmentProductPrint.vue